import { useEffect, useState } from "react";

import { ITrialLicense } from "@/base/NewselaGlobalLayoutV2/NavigationBar/PremiumTrial/TrialBanner/TrialBanner.types";
import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import fetchJson from "@/remoteState/fetchJson";

const useFetchLicenses = () => {
  const [licenses, setLicenses] = useState<ITrialLicense[]>([]);

  useEffect(() => {
    const fetchLicenses = async () => {
      const licensesData = await fetchJson(
        `${MONOLITH_ORIGIN}/api/v2/user/me/license/`,
      );
      setLicenses(licensesData as ITrialLicense[]);
    };
    void fetchLicenses();
  }, []);

  return licenses;
};

export { useFetchLicenses };
